module.exports = __webpack_public_path__ + "d7507dd7e72c41a4a2fc818a00ff9722.svg";